module.exports = __webpack_public_path__ + "static/video2-049a291e4525d7010bdbafd5acb234f0.png";